module.exports = __webpack_public_path__ + "img/mockup-desktop-aymeric.5ee5378f.png";